import axios, { AxiosRequestConfig } from "axios";
import { getAccessTokenObj, getLanguage } from "auth-provider";
import { AUTH_API_URL, PROJECT_CLIENT_ID } from "screens/register/util";
import { AccessTokenQueryKey } from "./oauth";

const TIME_OUT = process.env.NODE_ENV !== "production" ? 30 * 1000 : 15000; // 15 sec

export const defaultHeaders = {
  "client-id": PROJECT_CLIENT_ID,
  "Content-Type": "application/json",
  "api-service-region-id": "1",
};

export const POS_HEADERS = {
  "client-id": PROJECT_CLIENT_ID,
  "Content-Type": "application/json",
};

const lang = getLanguage();

const refreshAccessToken = async () => {
  const tokenObjStr = localStorage.getItem(AccessTokenQueryKey);
  if (!tokenObjStr) {
    return {};
  }
  try {
    const response = await instance({
      method: "post",
      url: `${AUTH_API_URL}/oauth/token`,
      params: { locale: lang },
      headers: { "client-id": PROJECT_CLIENT_ID },
      data: {
        refresh_token: JSON.parse(tokenObjStr)?.refresh_token,
        grant_type: "refresh_token",
      },
      validateStatus: (status) => status === 200,
    });

    if (!response || !response.data) {
      return {};
    }
    const accessTokenObj = response.data;
    if (response.status === 400 || response.status === 401 || response.status === 403) {
      logoutToken();
      return {};
    } else {
      if (accessTokenObj.access_token) {
        localStorage.setItem(AccessTokenQueryKey, JSON.stringify(accessTokenObj));
      }
      return accessTokenObj;
    }
  } catch (error) {
    return {};
  }
};

const logoutToken = async () => {
  const tokenObjStr = localStorage.getItem(AccessTokenQueryKey);
  if (!tokenObjStr) {
    return {};
  }
  try {
    const response = await instance({
      method: "post",
      url: `${AUTH_API_URL}/api/v1/logout`,
      headers: { "client-id": PROJECT_CLIENT_ID },
      data: {
        refresh_token: JSON.parse(tokenObjStr)?.refresh_token,
      },
      validateStatus: (status) => status === 200,
    });
    if (!response || !response.data) {
      return {};
    }
    return response.data;
  } catch (error) {
    return {};
  }
};

export const getHeaders = (originHeaders?: Partial<typeof defaultHeaders>) => {
  if (!originHeaders) {
    originHeaders = { ...defaultHeaders };
  }
  const accessTokenObj = getAccessTokenObj();
  if (!accessTokenObj?.access_token) {
    return originHeaders;
  }
  const headers = {
    Authorization: "",
  };
  headers.Authorization =
    accessTokenObj.token_type + " " + accessTokenObj.access_token;
  return { ...originHeaders, ...headers };
};

const instance = axios.create({
  timeout: TIME_OUT,
  validateStatus: (status) => {
    return status < 500;
  },
});

instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    // debugger
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

type AxiosRetryConfig = AxiosRequestConfig & { _retry?: boolean };

instance.interceptors.response.use(
  async function (response) {
    const originalRequest = response.config as AxiosRetryConfig;
    // 只有第一次出现 401才会刷新token；其他情况直接过
    if (response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const accessTokenObj = (await refreshAccessToken()) as any;
      const RequestHeaders = originalRequest?.headers as any;
      RequestHeaders["Authorization"] =
        accessTokenObj?.token_type + " " + accessTokenObj.access_token;
      return await instance(originalRequest);
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default instance;
